// import $ from 'jquery'

// CSRF protection for your AJAX Requests
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
})

// Not show right click on images
$(document).on('contextmenu', 'img', function() {
    return false
})
$(document).on('dragstart', 'img', function() {
    return false
})

$(() => {
    // Form
    $(document).on('click', '.form-control-placeholder', function() {
        $(this)
            .prev('.form-control')
            .focus()
    })

    // View more toggle effect
    $(document).on('click', '.view-more-toggle', function() {
        $('#bid-not-allowed-text').toggleClass('d-none d-sm-block')
        var useClass = $(this).attr('data-toggle-class')

        if (useClass == undefined) {
            $('#bid-bar').toggleClass('show-more')
        } else {
            $('#bid-bar').toggleClass(useClass)
        }
    })


    $(document).on('click', '.view-type-wrap .view-type', function() {
        if (!$(this).hasClass('active')) {
            var classes = $(this).attr('class')
            classes = classes.replace('view-type', '').replace(' ', '')
            $(this).parents('#lot-listing').find('.grid-wrap').attr('class', 'grid-wrap ' + classes)
            $(this).parent().find('.active').removeClass('active')
            $(this).toggleClass('active')
        }
    })
})

$(function() {
    $(document).on('click', '#auction-listing .pagination li a', function() {
        $('html, body').animate({ scrollTop: 0 }, 800)
        return false
    })

    // Hybrid Auction Scripts
    $(document).on('change', '.hybrid-bid-bar .switch-wrap input[type=checkbox]', function() {
        if ($(this).is(':checked')) {
            $('.hybrid-confirm-bid-wrap button').attr('disabled', false)
            $('.hybrid-bid-bar').addClass('lock-price')
        } else {
            $('.hybrid-confirm-bid-wrap button').attr('disabled', true)
            $('.hybrid-bid-bar').removeClass('lock-price')
        }
    })
    $(document).on('click', '.hybrid-current-lot-wrap', function() {
        $(this).toggleClass('opened')
    })

    $(document).on('click', '.metro-touch-device .hybrid-lots-wrap .content-box > h3:not(.opened)', function() {
        if ($(window).outerWidth() < 680 || $(window).outerWidth() < 991 && window.innerHeight < window.innerWidth) {
          $(this).parents(".lots-wrap").find(".content-box > h3.opened").removeClass("opened");
          $(this).addClass('opened')
        }
    })

    if ($('.activeHybridSystem').length > 0) {
        setTimeout(function() {
            var topVideo = $('.lot-header').offset().top
            $('html, body').animate({
                scrollTop: topVideo - 120,
            }, 800)
        }, 1000)
    }
    $('.activeHybridSystem').bind('mousewheel', function(event) {
        if (event.originalEvent.wheelDelta < 0) {
            setTimeout(function() {
                $('.hybrid-current-lot-wrap').removeClass('opened')
            })
        }
    })
})

let mobile = require('is-mobile')

function changeSelect(node){
    if (mobile({tablet: true})) {
        var selectedVal = $(node).val();
        // let nodeVal = $(node).data('select').val();
        // selectedVal !== nodeVal && $(node).data('select').val(selectedVal);
        $(node).data('select').val(selectedVal);
    }
}

// import './some-scripts-for-registration'

window.addEventListener('load', function () {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (!mutation.addedNodes) return

          for (var i = 0; i < mutation.addedNodes.length; i++) {
            // do things to your newly added nodes here
            var node = mutation.addedNodes[i]

              if(node.tagName == 'SELECT' && $(node).hasClass('form-control') && !$(node).hasClass("lang-choice")){
                  $(node).change(function(){
                      changeSelect(node);
                  });
              }
          }
        })
      });

      $(".metro-touch-device select.form-control:not(.lang-choice)").change(function(evt){
        if (!evt.detail) {
            changeSelect(this);
        }
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
      })
})


$("input").prop("placeholder"," ");

jQuery("input[type=password]").each(function(){
    
    let hasEye = $(this).find(".eye-pass").length;
    if(!hasEye){
        let input = $(this);
        let newEye = $("<span class='eye-pass'></span>");
        
        newEye.click(function(){ 
            
            if(input.hasClass('show-pass')){
                input.removeClass("show-pass").attr("type","password");

            } else {
                input.addClass("show-pass").attr("type","text");
            } 
        }); 
        input.siblings('label').after(newEye);
    }
});
